import $ from 'jquery';

export default class ContactFormHandler {
  constructor(config) {
    this._container = config.container;
    this._init();
  }

  _calculateIconPosition(el) {
    var btn = $('.btn');
    var btnValue = btn.val();
    var size = btnValue.length * 10;
    var value = (btn.outerWidth() - size) / 2 + size + (btn.outerWidth() - size) / 4 - el.width() / 2;

    return value;
  }

  _init() {
    var contactForm = this._container;

    var _self = this;
    var submitButton = contactForm.find('input[type="submit"]');
    submitButton.click(function(event) {
      event.preventDefault();

      contactForm.find('.error').removeClass('error');
      contactForm.find('.input__error').remove();
      contactForm.find('.icon').removeClass('active');

      var checkIcon = contactForm.find('.check-icon');
      var loadingIcon = contactForm.find('.loading-icon');
      loadingIcon.addClass('active');
      loadingIcon.css('left', _self._calculateIconPosition(loadingIcon));

      var utmSource = window.getCookie('utm_source');
      if (utmSource !== 'null') {
        contactForm.find('#utm-source').val(utmSource);
      }
      var utmMedium = window.getCookie('utm_medium');
      if (utmMedium !== 'null') {
        contactForm.find('#utm-medium').val(utmMedium);
      }
      var utmCampaign = window.getCookie('utm_campaign');
      if (utmCampaign !== 'null') {
        contactForm.find('#utm-campaign').val(utmCampaign);
      }
      var utmTerm = window.getCookie('utm_term');
      if (utmTerm !== 'null') {
        contactForm.find('#utm-term').val(utmTerm);
      }
      var utmContent = window.getCookie('utm_content');
      if (utmContent !== 'null') {
        contactForm.find('#utm-content').val(utmContent);
      }

      $.ajax({
        url: contactForm.attr('action'),
        type: 'POST',
        data: contactForm.serialize(),
        dataType: 'json',
        success: function(response) {
          if (response['status'] === 'success') {
            submitButton.addClass('btn_success');
            submitButton.prop('value', response['message']);
            submitButton.prop('disabled', true);
            submitButton.css('cursor', 'default');

            loadingIcon.removeClass('active');
            checkIcon.addClass('active');
            checkIcon.css('left', _self._calculateIconPosition(checkIcon));

            if (typeof window.dataLayer === 'undefined') { window.dataLayer = []; }
            window.dataLayer.push({'event':  'contact_form_filled_out'});
          } else if (response['status'] === 'validation') {
            $.each(response.errors, function(index, value) {
              contactForm.find('#inp-'+index).parent().addClass('error');
              contactForm.find('#inp-'+index).before('<div class="input__error">' + value + '</div>');
            });

            friendlyChallenge.autoWidget.reset();

            $('html, body').animate({
              scrollTop: contactForm.find('.error').first().offset().top - $('.header').outerHeight()
            }, 1000);

            loadingIcon.removeClass('active');
          }
        },
      });
    });
  }
}
